export default {
  'keyword': 'Keyword',
  'section': 'Section',
  'url_status': 'URL Status',
  'url_match': 'Matched URLs',
  'url': 'Mapped URL',
  'published_url': 'Published URL',
  'url_page_type': 'Page Type',
  'score': 'Rel Score',
  'rank_current_url': 'Ranking URL',
  'metric_rank_current': 'Ranking',
  'metric_rank_timestamp_current': 'Rank Timestamp',
  'metric_rank_timestamp_baseline': 'Baseline Rank Timestamp',
  'rank_baseline_url': 'Baseline Ranking URL',
  'metric_rank_baseline': 'Baseline Ranking',
  'metric_rank_zone_baseline': 'Baseline Rank Zone',
  'metric_rank_zone_current': 'Rank Zone',
  'metric_rank_zone': 'Rank Zone',
  'metric_msv_broad_adjusted_1': 'MSV 1',
  'metric_msv_broad_adjusted_2': 'MSV 2',
  'metric_msv_broad_adjusted_3': 'MSV 3',
  'metric_msv_broad_adjusted_4': 'MSV 4',
  'answer_box': 'SERP: Answer Box',
  'brand_pack': 'SERP: Brand Pack',
  'image_pack': 'SERP: Image Pack',
  'knowledge_graph': 'SERP: Knowledge Graph',
  'local_3_pack': 'SERP: Local 3 Pack',
  'news_pack': 'SERP: News Pack',
  'people_also_ask': 'SERP: PAA',
  'related_searches': 'SERP: Related Searches',
  'shopping_box': 'SERP: Shopping Box',
  'video_pack': 'SERP: Video Pack',
  'ad_count': 'SERP: Ad Count',
  'geo': 'SERP: Geo',
  'locale': 'SERP: Locale',
  'total_number_of_results': 'SERP: Total Results',
  'content_brief_status': 'CB Status',
  'writing_status': 'Writing Status',
  'attribute': 'Keyword Attribute',
  'url_optimized': 'Is Optimized',
  'difficulty_score': 'Difficulty Score',
  'rank_blur_count': 'Rank Blur Count',
  'seller_cards': 'Your Store\'s Cards',
  'total_product_cards': 'Total Product Cards',
  'product_grids': 'Product Grids'
  // 'url_attribute': 'URL Attributes'
}
